
import { subcategoryPath } from '@/shared/lib/routes';

export interface DraftEntryTarget {
  categoryId: string | null;
  subcategoryId: string | null;
}

export function draftEntryPath(draft: DraftEntryTarget | null): string {
  if (draft?.categoryId && draft.subcategoryId) {
    return subcategoryPath(draft.categoryId, draft.subcategoryId);
  }
  return '/categories';
}
